import { defineComponent as _defineComponent } from 'vue'
import { defineComponent } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'no-results-message-extras',
  setup(__props) {


defineComponent({
  name: 'NoResultsMessageExtras',
});


return { __sfc: true, }
}

})